import { IStoryContent } from '@opengov/stories-shared/types';
import { removeContentMedia } from '../../../../utils/dom';

export function clearTableMarkupFromStoryContent({
  storyContent,
  mediaIndex
}: {
  storyContent: IStoryContent;
  mediaIndex: number;
}) {
  const storyContentWithoutMarkup = removeContentMedia(storyContent.content, mediaIndex);
  return { ...storyContent, shouldUpdate: true, content: storyContentWithoutMarkup };
}
